import { lazy } from 'react';

export const TermsConditions = lazy(
	() =>
		import(
			/* webpackChunkName: "termsandcond" */
			'./terms-conditions.js'
		)
);

export const PrivacyPolicy = lazy(() => import(/* webpackChunkName: "privpolicy" */ './privacy-policy.js'));

export const CookiePolicy = lazy(() => import(/* webpackChunkName: "cookiepolicy" */ './cookie-policy.js'));

export const ResponsibleGaming = lazy(
	() =>
		import(
			/* webpackChunkName: "respgaming" */
			'./responsible-gaming.js'
		)
);

export const About = lazy(() => import(/* webpackChunkName: "about" */ './about.js'));

export const UserFeedback = lazy(
	() =>
		import(
			/* webpackChunkName: "responsive-user-feedback" */
			'./user-feedback.js'
		)
);

export const TermsConditionsBonus = lazy(
	() =>
		import(
			/* webpackChunkName: "terms-conditions-bonus" */
			'./terms-conditions-bonus.js'
		)
);

export const Bonus = lazy(() => import(/* webpackChunkName: "bonus" */ './bonus.js'));

export const FreeBet = lazy(
	() => import(/* webpackChunkName: "freebet" */ '~/components/pages/polish-pages/freebet.js')
);
export const ComplaintProcedure = lazy(
	() => import(/* webpackChunkName: "complaint-procedure" */ '~/components/pages/ksa-pages/complaint-procedure.js')
);

export const LegalBetting = lazy(
	() =>
		import(
			/* webpackChunkName: "legal-betting" */
			'~/components/pages/polish-pages/legal-betting.js'
		)
);

export const BettingTips = lazy(
	() =>
		import(
			/* webpackChunkName: "betting-tips" */
			'~/components/pages/polish-pages/betting-tips.js'
		)
);

export const Tax = lazy(() => import(/* webpackChunkName: "tax" */ '~/components/pages/polish-pages/tax.js'));

export const Payments = lazy(
	() => import(/* webpackChunkName: "payments" */ '~/components/pages/polish-pages/payments.js')
);

export const Verification = lazy(
	() => import(/* webpackChunkName: "verification" */ '~/components/pages/polish-pages/verification.js')
);

export const Hub = lazy(
	() => import(/* webpackChunkName: "global-navigation" */ '~/components/global-navigation/hub/hub')
);
